import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import EmployerDashboardNav from '../employer/EmployerDashboardNav';
import axios from 'axios';
import { useAuth } from '../../AuthContext';
import { ToastContainer, toast } from "react-toastify";
import Breadcrumb from '../Breadcrumb';

const AllCandidatesCard = ({ element }) => {
  const {
    userid,
    city,
    college,
    university,
    currentSalary,
    currentcompany,
    currentDesignation,
    githubid,
    linkedinid,
    profilePicture,
    skills = [],
    address
  } = element;

  return (
    <div className="candidate-card h-100 shadow-sm p-4 bg-white rounded">
      <div className="d-flex align-items-start mb-3">
        <div className="candidate-img me-3">
          <img
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
            src={profilePicture || "assets/img/team/default.jpg"}
            alt="Candidate"
            className="rounded-circle"
            style={{ width: '80px', height: '80px', objectFit: 'cover' }}
          />
        </div>
        
        <div className="candidate-header">
          <h5 className="mb-1 text-dark">
            {userid ?? "N/A"}
          </h5>
          <p className="text-muted mb-2" style={{ fontSize: '0.9rem' }}>
            {currentDesignation ?? "N/A"}
          </p>
          <div className="d-flex align-items-center text-muted" style={{ fontSize: '0.85rem' }}>
            <i className="fas fa-map-marker-alt me-2"></i>
            {address ?? "N/A"}
          </div>
        </div>
      </div>

      {/* Skills */}
      <div className="skills-wrapper mb-3">
        <div className="d-flex flex-wrap gap-2">
          {/* {skills.map((skill, index) => (
            <span 
              key={index}
              className="badge bg-light text-primary"
              style={{ padding: '8px 12px', fontSize: '0.85rem' }}
            >
              {skill}
            </span>
          ))} */}
          {/* Adding default skills based on the data */}
          <span className="badge bg-light text-primary" style={{ padding: '8px 12px', fontSize: '0.85rem' }}>
            {currentcompany}
          </span>
          <span className="badge bg-light text-primary" style={{ padding: '8px 12px', fontSize: '0.85rem' }}>
            {city}
          </span>
        </div>
      </div>

      {/* Additional Details */}
      <div className="additional-details mb-3">
        <div className="text-muted" style={{ fontSize: '0.9rem' }}>
          <div className="mb-1"><strong>College:</strong> {college ?? "N/A"}</div>
          <div className="mb-1"><strong>University:</strong> {university ?? "N/A"}</div>
        </div>
      </div>

      {/* Footer */}
      <div className="card-footer d-flex justify-content-between align-items-center p-0 pt-3 border-top">
        <div className="salary">
          <span className="text-primary fw-bold" style={{ fontSize: '1.2rem' }}>
            ₹{currentSalary ?? "N/A"}
          </span>
          {/* <span className="text-muted ms-1">/year</span> */}
        </div>

        <div className="d-flex align-items-center">
          {/* Social Links */}
          <div className="social-links me-3">
            {linkedinid && (
              <a
                href={linkedinid}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary me-2"
              >
                <i className="fab fa-linkedin fa-lg"></i>
              </a>
            )}
            {githubid && (
              <a
                href={githubid}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary"
              >
                <i className="fab fa-github fa-lg"></i>
              </a>
            )}
          </div>

          <button className="btn btn-primary px-4">
            View Profile
          </button>
        </div>
      </div>
    </div>
  );
};

const CandidatePage = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [candidatesPerPage] = useState(9);

  useEffect(() => {
    if (!auth.isAuthenticated || auth.role === 'employer') {
      navigate('/login');
      return;
    }
  }, [auth.isAuthenticated, auth.role, navigate]);

  async function getCandidate() {
    setLoading(true);
    try {
      const baseUrl = process.env.REACT_APP_API_URL;
      const url = `${baseUrl}candidate_details/showallcandidate`;
      
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const response = await axios.get(url, config);
      setCandidates(response.data);
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Error fetching candidates';
      setError(errorMessage);
      toast.error(errorMessage);
      
      if (error.response?.status === 401) {
        localStorage.clear();
        navigate('/login');
      }
    }
    setLoading(false);
  }

  useEffect(() => {
    if (auth.isAuthenticated) {
      getCandidate();
    }
  }, [auth.isAuthenticated]);

  // Get current candidates
  const indexOfLastCandidate = currentPage * candidatesPerPage;
  const indexOfFirstCandidate = indexOfLastCandidate - candidatesPerPage;
  const currentCandidates = candidates.slice(indexOfFirstCandidate, indexOfLastCandidate);

  // Change page
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0); // Scroll to top when page changes
  };

  const totalPages = Math.ceil(candidates.length / candidatesPerPage);

  if (!auth.isAuthenticated) {
    return null;
  }

  if (loading) {
    return (
      <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading candidates...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer autoClose={2000} />
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">All Candidates</h2>
          <ul className="breadcrumb-menu">
            <li>
              <Link to="/employerdashboard">Home</Link>
            </li>
            <li className="active">All Candidates</li>
          </ul>
        </div>
        <div className="hero-shape">
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
        </div>
      </div> */}
      <Breadcrumb
        title="All Candidates"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "All Candidates", active: true }
        ]}
      />

      <div className='user-profile py-120'>
        <div className='container'>
          <div className='row justify-content-evenly'>
            <div className='col-lg-11'>
              <div className='row g-4 justify-content-evenly'>
                {!error && currentCandidates.length > 0 ? (
                  currentCandidates.map((ele) => (
                    <div 
                      key={ele.userid || Math.random() * 1000} 
                      className='col-md-4 px-4'
                    >
                      <AllCandidatesCard element={ele} />
                    </div>
                  ))
                ) : error ? (
                  <div className="col-12">
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  </div>
                ) : (
                  <div className="col-12">
                    <div className="alert alert-info" role="alert">
                      No candidates found
                    </div>
                  </div>
                )}
              </div>

              {!error && candidates.length > 0 && (
                <div className="d-flex justify-content-center mt-5">
                  <nav aria-label="Candidates pagination">
                    <ul className="pagination">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button 
                          className="page-link px-4 py-2 text-white bg-primary border-primary" 
                          onClick={() => paginate(currentPage - 1)}
                          disabled={currentPage === 1}
                          style={{
                            minWidth: '100px',
                            textAlign: 'center',
                            transition: 'all 0.3s ease',
                            opacity: currentPage === 1 ? '0.65' : '1'
                          }}
                        >
                          Previous
                        </button>
                      </li>
                      
                      {[...Array(totalPages)].map((_, index) => (
                        <li 
                          key={index + 1} 
                          className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                        >
                          <button
                            className={`page-link ${
                              currentPage === index + 1 
                                ? 'bg-primary text-white border-primary' 
                                : 'text-primary'
                            }`}
                            onClick={() => paginate(index + 1)}
                            style={{
                              minWidth: '45px',
                              textAlign: 'center',
                              transition: 'all 0.3s ease'
                            }}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button 
                          className="page-link px-4 py-2 text-white bg-primary border-primary"
                          onClick={() => paginate(currentPage + 1)}
                          disabled={currentPage === totalPages}
                          style={{
                            minWidth: '100px',
                            textAlign: 'center',
                            transition: 'all 0.3s ease',
                            opacity: currentPage === totalPages ? '0.65' : '1'
                          }}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CandidatePage;